import { PositionProgramsActionEnum } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/types";
import { FormStatus } from "~/shared/lib/statuses";

export type Course = {
  id: string;
  status: FormStatus;
  dateActiveStatus?: string;
  dateInactiveStatus?: string;
  createdAt?: string;
  updatedAt?: string;
  certificateValidityPeriod?: number;
  name?: string;
  __typename?: string;
  isDisabled?: boolean;
  value?: string;
  label?: string;
};
export type TLevel = {
  id: string;
  courses: Course[];
  action: PositionProgramsActionEnum;
  name: string;
  status: FormStatus;
  sequenceNumber: number;
  isCertification: boolean;
};

export type Positions = {
  id: string;
  name: string;
};

export interface TrainingProgram {
  PositionGroupId?: string;
  PositionsIds?: [];
  name?: string;
  levels: TLevel[];
}
export interface DataTrainingProgram {
  Positions: Positions[];
  levels: TLevel[];
}

interface IProgram {
  id: string;
  name: string;
  status: string;
  InstanceId: string;
  ActualFrom: string;
  ActualTo: string;
  code: string;
}

interface IDateStatus {
  dateActiveStatus: string;
  dateInactiveStatus: string;
}

interface IDate {
  createdAt: string;
  updatedAt: string;
}

export interface IGroup extends IProgram, IDateStatus {
  sequenceNumber: number;
}

export interface ILevel extends IProgram, IDate, IDateStatus {
  validity: string;
  sequenceNumber: number;
  isCertification: boolean;
  GroupId: number;
  Group: IGroup;
}

export type SelectOptions = {
  value: string;
  label: string;
};

export enum TableName {
  group,
  level,
}

export type EntityRefetch = (variables?: {
  ActualOn?: Date | string | null;
}) => Promise<unknown>;

export interface EntityData<T> {
  data: unknown;
  loading: boolean;
  refetch: EntityRefetch;
  tableItems: T[];
  totalRecords: number;
}

export interface CurriculumManagementProps {
  formId: string;
  refetch: EntityRefetch;
  closeModal: () => void;
}
